export const SERVER_URL = ''; // 서버 URL을 여기에 설정합니다.

